import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetPaymentById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import DoubleField from "../../components/DoubleField";
import TextInputField from "../../components/TextInputField";

const ViewPayment = () => {
  const navigate = useNavigate();
  let param = useParams();
  const payment_id = param.r_id;
  const [formData, setFormData] = useState({
    account_from: "",
    account_to: "",
    amount: "0.0",
    notes: "",
  });

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Payment");
  };

  useEffect(() => {
    async function fetchData() {
      if (payment_id) {
        TimeoutUtility.resetTimeout();
        await GetPaymentById(payment_id)
          .then((result) => {
            setFormData({
              account_from: result.data.acc_from,
              account_to: result.data.acc_to,
              amount: result.data.amount_paid,
              notes: result.data.note,
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [payment_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW PAYMENT" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} sm={8} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Paid To:"
                  name="account_to"
                  value={formData.account_to}
                  placeholder="Paid To Account"
                  disabled
                />
                <TextInputField
                  label="Paid From:"
                  name="account_from"
                  value={formData.account_from}
                  placeholder="Paid From Account"
                  disabled
                />
                <DoubleField
                  label="Amount Paid:"
                  name="amount"
                  value={formData.amount}
                  placeholder="Amount Paid"
                  disabled
                />
                <TextAreaField
                  label="Notes:"
                  name="notes"
                  value={formData.notes}
                  placeholder="Notes"
                  disabled
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewPayment;
